import React, { useEffect, useRef, useState } from "react";
import { Button } from "@opendate-app/setlist";

import TemplateEditor from "../../BeefreeTemplates/TemplateEditor";
import { useTemplateAutosave } from "../../../../shared/useTemplateAutosave";
import { useLandingPage } from "../LandingPageBuilderContainer";

const styles = {
  toolbar: { display: "flex", alignItems: "center", gap: 12, marginBottom: 12 },
  saveState: { fontSize: 13, color: "var(--sl-text-tertiary)" },
};

const FullEditor = ({ onDone }) => {
  const { page, props, savePage } = useLandingPage();
  const [initialTemplate] = useState(page.template);
  const [saveFailed, setSaveFailed] = useState(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);
  const { isAutosaving, autosave } = useTemplateAutosave(async (template) => {
    const saved = await savePage({ template });
    if (mounted.current) setSaveFailed(!saved);
  });
  const saveState = isAutosaving ? "Saving…" : (saveFailed ? "Not saved" : "Saved");

  return (
    <>
      <div style={styles.toolbar}>
        <Button variant="primary" size="sm" onClick={() => { autosave.flush(); onDone(); }}>Done</Button>
        <span style={styles.saveState} role="status">{saveState}</span>
      </div>
      <TemplateEditor
        mergeTags={[]}
        autosave
        onAutosave={autosave}
        style={{ height: "calc(100vh - 280px)", minHeight: 480 }}
        templatableContext={() => ({
          csrfToken: props.csrfToken,
          team: props.team,
          beefreeToken: props.beefreeToken,
          template: initialTemplate,
          setTemplate: () => {},
          processedTemplate: initialTemplate,
        })}
      />
    </>
  );
};

export default FullEditor;
